import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { SURFACE_LEGEND } from './surface.legend';
import { SURFACE_PRODUCT_DATA } from './surface.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class SurfacePluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(SURFACE_PRODUCT_DATA, {
    legend: SURFACE_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
